export enum Provider {
  PUSHER = 'pusher',
  CENTRIFUGO_DEV_ONLY = 'centrifugo',
}

export type RealtimePluginOptions =
  | {
      provider: Provider.PUSHER
      dsn: string
    }
  | {
      provider: Provider.CENTRIFUGO_DEV_ONLY
      project: string
      dsn: string
    }
